import React from 'react'
import {AiOutlinePlus} from 'react-icons/ai';
import {AiOutlineMinus} from 'react-icons/ai';
import { BsXLg } from "react-icons/bs";
const CartItems = () => {
  return (
    <div className='w-full relative flex p-2 border border-gray-200 mb-2 rounded-sm'>
      <button className='text-lg absolute right-2 text-jet font-light '> <BsXLg/></button>
     <div className='basis-3/12 p-2.5'>
         <img src="/images/cartshoes.jpg" className='w-full' alt="" />
     </div>

     <div className='basis-8/12 p-2'>
       <h1 className='text-sm font-semibold mb-1'>HRX by Hritik Roshan</h1>
       <h2 className='text-sm text-gray-jet mb-1'>Men Active Gray Core 1.0 Running Shoe  </h2>
       <h3 className='text-xs  text-gray-web mb-1'>Sold by <span className='font-semibold text-frostbite'>Apna Mart</span></h3>
       <div className='flex w-42 py-3 '>
         <button className='border text-xl px-2 font-bold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500  rounded-sm'><AiOutlinePlus/></button>
         <span className='px-4 font-semibold text-jet'>5</span>
         <button className='border text-xl px-2 font-bold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500 rounded-sm'><AiOutlineMinus/></button>
       </div>
       <div>
       <span className='font-medium  text-md p-1'> ₹ 787</span> 
       <span className='text-gray-web line-through text-medium font-medium p-1'>₹ 1242</span>
       <span className='text-positive font-semibold text-sm py-1 pl-1'>You Save ₹ 76.00 </span>
       </div>
     </div>
    </div>
  )
}

export default CartItems





